import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class ConfirmDialogService {

	private _isOpen: boolean = false;
	isOpen: BehaviorSubject<boolean>;

	constructor() {
		this.isOpen = new BehaviorSubject(this._isOpen);
	}

	/**
	 * Close confirm dialog
	 */
	closeConfirmDialog() {
		this._isOpen = false;
		this.isOpen.next(this._isOpen);
	}

	/**
	 * Opens confirm dialog
	 */
	openConfirmDialog() {
		this._isOpen = true;
		this.isOpen.next(this._isOpen);
	}

	/**
	 * Get if is open
	 */
	getIsOpen() {
		return this._isOpen;
	}

	/**
	 * Focus on confirm dialog
	 */
	focusConfirmDialog() {
		const CONFIRM_DIALOG = document.getElementById('app-confirm-dialog');
		if (CONFIRM_DIALOG) {
			CONFIRM_DIALOG.focus();
		}
	}
}
